import React from 'react';
import {
  Control,
  Controller,
  FieldValues,
  get,
  Path,
  useFormState,
} from 'react-hook-form';
import clsx from 'clsx';
import ControllerSelect from '../ui/ControllerSelect';
import { Props } from 'react-select';

interface StyledSelectProps<FieldsType extends FieldValues> extends Props {
  title?: string;
  name: Path<FieldsType>;
  control: Control<FieldsType>;
  className?: React.HTMLAttributes<HTMLDivElement>['className'];
  placeholder?: string;
  disabled?: boolean;
  creatable?: boolean;
  onCreateOption?: (option: string) => void;
}

const StyledSelect = <FieldsType extends FieldValues>({
  title,
  control,
  name,
  className,
  placeholder,
  disabled = false,
  creatable = false,
  ...props
}: StyledSelectProps<FieldsType>) => {
  const { errors } = useFormState({ control });
  const errorMessage = get(errors, name + '.message') as unknown as string;

  return (
    <div className={clsx('flex flex-col w-full gap-1.5', className)}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <ControllerSelect
            field={field}
            {...props}
            title={title}
            errorMessage={errorMessage}
            name={name}
            placeholder={placeholder}
            disabled={disabled}
            creatable={creatable}
          />
        )}
      />
      {errorMessage !== '' && (
        <p className="text-sm leading-6 font-medium text-error-500">
          {errorMessage}
        </p>
      )}
    </div>
  );
};

export default StyledSelect;
